import { ArrowLeft, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";

interface StepNavigationProps {
  backPath?: string | null;
  nextPath?: string | null;
  nextLabel?: string;
  backLabel?: string;
  onNext?: () => Promise<boolean> | boolean;
  nextDisabled?: boolean;
  nextDisabledReason?: string;
}

export function StepNavigation({
  backPath,
  nextPath,
  nextLabel = "Continue",
  backLabel = "Back",
  onNext,
  nextDisabled,
  nextDisabledReason,
}: StepNavigationProps) {
  const navigate = useNavigate();

  async function handleNext() {
    if (onNext) {
      const ok = await onNext();
      if (!ok) return;
    }
    if (nextPath) navigate(nextPath);
  }

  return (
    <div className="mt-auto flex flex-wrap items-center justify-between gap-3 border-t border-border/60 pt-6">
      <Button
        variant="ghost"
        disabled={!backPath}
        onClick={() => backPath && navigate(backPath)}
      >
        <ArrowLeft className="size-4" /> {backLabel}
      </Button>
      <div className="flex items-center gap-3">
        {nextDisabled && nextDisabledReason ? (
          <span className="text-xs text-muted-foreground">{nextDisabledReason}</span>
        ) : null}
        <Button onClick={handleNext} disabled={nextDisabled || (!nextPath && !onNext)}>
          {nextLabel} <ArrowRight className="size-4" />
        </Button>
      </div>
    </div>
  );
}
